module.exports = __webpack_public_path__ + "img/weixin.0f4a7f51.png";